<div>
  <span class="underline" *ngIf="currentPage">{{currentPage.page}}</span> / <span>{{maxPage}}</span>
</div>
